export enum OnboardingAccountingManagement {
  AccountingFirm = 4,
  Advisor = 3,
  Myself = 1,
  SplitWorkWithAdvisor = 2,
}
